import { useMemo } from 'react';
import { Stack } from '@mui/material';

import { CloseCircleIcon } from '~assets/icons';
import { AutoCompleteSingleChip } from '~components/atoms';
import { CustomPopperComponent } from '~components/atoms/custom/autocomplete/AutoCompleteSingleField';
import { useSearchUnassignedStation } from '~hooks/useSearchUnassignedStation';
import { StationFilterOption } from '~types';

type Props = {
  station: StationFilterOption | null;
  onChangeStation: (
    event: React.SyntheticEvent,
    value: StationFilterOption | null,
  ) => void;
};

export const SelectStationStep: React.FC<Props> = ({
  station,
  onChangeStation,
}) => {
  const { getUnassignedStationQuery, onSearchUnassignedStation } =
    useSearchUnassignedStation();

  const stationOptions = useMemo<StationFilterOption[]>(() => {
    return (
      getUnassignedStationQuery.data?.data?.map((elem) => ({
        id: elem.id,
        name: elem.imei,
        imei: elem.imei,
        serialNumber: elem.serialNumber,
        type: elem.type,
      })) ?? []
    );
  }, [getUnassignedStationQuery.data?.data]);

  return (
    <AutoCompleteSingleChip
      value={station}
      options={stationOptions}
      onSearching={onSearchUnassignedStation}
      onChange={onChangeStation}
      textFieldProps={{
        placeholder: 'Select by IMEI',
      }}
      clearIcon={
        <Stack marginRight={0.5}>
          <CloseCircleIcon />
        </Stack>
      }
      popupIcon={null}
      PopperComponent={CustomPopperComponent}
    />
  );
};
